import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, Card, Select, message } from 'antd';
import Input from '../../ui/Input';
import TextArea from '../../ui/TextArea';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import { LocalPersistence } from '../../../factories';
import { addOtherFeeTax } from '../../../services/otherPayments';
import PageContainer from '../../CSIComponents/PageContainer';
import Loading from '../../Loading';

const { Option } = Select;
const AddOtherFeeTax = (props: any) => {
  const [disableFlag, setDisableFlag] = useState(true);
  const [chargeName, setChargeName] = useState('');
  const [form] = Form.useForm();
  const [addLoading, setAddLoading] = useState(false)

  const validateForm = () => {
    form.validateFields().then(() => {
      setDisableFlag(false)
    }).catch(err => {
      err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
    });
  }
  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [chargeName])

  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()

      if (value['charge (Percent)']) {
        value.charge = value['charge (Percent)'];
        delete value['charge (Percent)'];
      } else {
        value.charge = value['charge (Amount)']
        delete value['charge (Amount)'];
      }

      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "otherpayments": {
            "otherfeetax": [
              {
                ...value
              }
            ]
          }
        }
      }
      setAddLoading(true)
      const res = await addOtherFeeTax(params);
      if (res.result.success) {
        form.resetFields();
        props.cancelAddAndEdit();
      } else {
        message.error({
          content: res?.errors[0]?.message
        });
      }
      setAddLoading(false)
    })
  }

  if (addLoading) return <Loading type='large' />
  return (
    <PageContainer>
      <Card className='db-page'>
        <Grid container spacing={0} className='py-0'>
          <Grid item xs={12} className='p-0'>
            <div className='db-title-wrap'>
              <div className='db-title'>Other Fee Tax</div>
            </div>
          </Grid>
          <Grid item xs={12} className='db-content-wrap pb-0 px-0 my-0'>
            <Form
              layout='vertical'
              form={form}
              name='basic'
              onValuesChange={validateForm}>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item label='Fee Tax Type' name='feetaxtype'>
                    <Select allowClear showSearch>
                      <Option value='Value Added Tax Food Beverage'>
                        Value Added Tax Food Beverage
                      </Option>
                      <Option value='Other Tax'>Other Tax</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label='Application' name='application'>
                    <Select allowClear showSearch>
                      <Option value='Inclusive'>Inclusive</Option>
                      <Option value='Exclusive'>Exclusive</Option>
                      <Option value='Cumulative '>Cumulative </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name='chargetype'
                    label='Charge Type'
                    rules={[
                      { required: true, message: 'This field is required' },
                    ]}>
                    <Select allowClear onChange={(value) => setChargeName(`Charge (${value})`)}
                      showSearch>
                      <Option value='Amount'>Amount</Option>
                      <Option value='Percent'>Percent</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
                <>
                  {chargeName === 'Charge (Amount)' && (
                    <>
                      <Col span={6}>
                        <Form.Item
                          label='Charge (Amount)'
                          name='charge (Amount)'
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                            {
                              pattern: /^\d*(\.\d*)?$/,
                              message: 'This field should be a number',
                            },
                          ]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
                <>
                  {chargeName === 'Charge (Percent)' && (
                    <>
                      <Col span={6}>
                        <Form.Item
                          label='Charge (Percent)'
                          name='charge (Percent)'
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                            {
                              pattern: /^\d*(\.\d*)?$/,
                              message: 'This field should be a number',
                            },
                          ]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
              </Row>
              <Row gutter={24}>
                <Col span={18}>
                  <Form.Item
                    label='Description'
                    name='description'
                    rules={[
                      {
                        max: 300,
                        message:
                          'You have reached the max character length of 300',
                      },
                    ]}>
                    <TextArea
                      maxLength={300}
                      maxRows={3}
                      placeholder='Description'
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onCancel={() => {
          props.cancelAddAndEdit()
          form.resetFields()
        }}
        onSave={addSave}
        disabledSave={disableFlag}
      />
    </PageContainer>
  )
}
export default AddOtherFeeTax;
